import { useEffect, useState } from 'react'
import { motion, useReducedMotion } from 'motion/react'
import { NavLink } from '../lib/router'
import type { SocialLinks } from '../types'

interface HeaderProps {
  socialLinks: SocialLinks
}

export function Header({ socialLinks }: HeaderProps) {
  const [open, setOpen] = useState(false)
  const reduceMotion = useReducedMotion()

  useEffect(() => {
    document.documentElement.classList.toggle('nav-open', open)
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setOpen(false)
    }
    const closeAtDesktop = () => {
      if (window.innerWidth > 760) setOpen(false)
    }
    window.addEventListener('keydown', closeOnEscape)
    window.addEventListener('resize', closeAtDesktop)
    return () => {
      document.documentElement.classList.remove('nav-open')
      window.removeEventListener('keydown', closeOnEscape)
      window.removeEventListener('resize', closeAtDesktop)
    }
  }, [open])

  const socialLink = (label: 'Github' | 'LinkedIn', href: string | null) => href ? (
    <a href={href} target="_blank" rel="noreferrer" onClick={() => setOpen(false)}>{label}<span className="external-mark" aria-hidden="true">↗</span></a>
  ) : (
    <span className="nav-disabled" aria-disabled="true" title={`${label} link coming soon`}>{label}<span className="soon-mark">Soon</span></span>
  )

  return (
    <motion.header
      className="site-header"
      initial={reduceMotion ? false : { opacity: 0, y: -14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: reduceMotion ? 0.01 : 1, delay: reduceMotion ? 0 : 0.18, ease: [0.22, 1, 0.36, 1] }}
    >
      <NavLink className="monogram" to="/" aria-label="Angel Rodriguez home" onClick={() => setOpen(false)}>A<span>R</span></NavLink>
      <button
        className="menu-toggle"
        type="button"
        aria-expanded={open}
        aria-controls="primary-navigation"
        aria-label={open ? 'Close navigation' : 'Open navigation'}
        onClick={() => setOpen((value) => !value)}
      >
        <span /><span />
      </button>
      <nav id="primary-navigation" className={open ? 'primary-nav is-open' : 'primary-nav'} aria-label="Primary navigation">
        <NavLink to="/" end onClick={() => setOpen(false)}>Home</NavLink>
        <NavLink to="/work" onClick={() => setOpen(false)}>My Portfolio</NavLink>
        <NavLink to="/about" onClick={() => setOpen(false)}>About Me</NavLink>
        {socialLink('Github', socialLinks.github)}
        {socialLink('LinkedIn', socialLinks.linkedin)}
      </nav>
    </motion.header>
  )
}
